import { createAction } from 'redux-actions';
import * as types from '../constants/ActionTypes';

export const backEndError = createAction(types.FIRE_BACKEND_ERROR);
export const agencySubIdError = createAction(types.FIRE_AGENCY_SUB_ID_ERROR);
export const customerError = createAction(types.FIRE_CUSTOMER_INFO_ERROR);
export const finalCleaningError = createAction(types.FIRE_FINAL_CLEANING_ERROR);
export const customerValidField = createAction(types.CLEAN_CUSTOMER_ERROR);
export const paymentError = createAction(types.FIRE_PAYMENT_ERROR);
export const voucherError = createAction(types.FIRE_VOUCHER_ERROR);
export const abandonBasketError = createAction(types.FIRE_ABANDON_BASKET_ERROR);
export const termsError = createAction(types.FIRE_TERMS_AND_CONDITIONS_ERROR);
